let strengthIncrement = 0.1;

class SwayStudy {

    //   PApplet p;
    //   Transmitter d;
    //     DataProvider dp;


    //   let sum = 0;

    //   boolean changeCenter = false;
    //   int lastSignalSum = 0;
    //   int frameStart;
    //   int frameElapseMaxInterval = 100;
    //   int minSignalThreshold = 20;
    //   ArrayList<Integer> signalRunValues = new ArrayList<Integer>();

    //   //int xIncrement = 20;
    //   //int yIncrement = 20;
    //   int xIncrement = 15;
    //   int yIncrement = 15;

    //   int xPositionsLength;
    //   int yPositionsLength;

    //   float[] strengths = new float[0];
    //   float[] oscillations = new float[0];
    //   float[] oscillationsY = new float[0];

    //   float[] sizes = new float[0];

    //   PVector center;
    //   let maxDistanceFromEpicenter;

    //   let r = 0;

    //   int w, h;

    //   let rx = 0;
    //   let ry = 0;

    //   ParticleSystem ps;
    //   ArrayList<Particle> particles;





    constructor(sketch, w, h, ps, dp) {
        this.sketch = sketch;
        this.w = w;
        this.h = h;
        this.dp = dp;

        this.ps = ps;
        this.particles = ps.systemParticles();

        this.maxDistanceFromEpicenter = w;

        this.strengths = [];
        this.oscillations = [];
        this.sizes = [];
        this.oscillationsY = [];

        for (let i = 0; i < this.particles.length; i++) {
            this.strengths[i] = 0;
            this.oscillations[i] = 0;
            this.oscillationsY[i] = 0;
            this.sizes[i] = 0;
        }

        this.center = this.sketch.createVector(w / 2, h / 2);

        this.frameStart = this.sketch.frameCount;

        this.phaseNumber = 1;

    }

    reset() {

        for (let i = 0; i < this.particles.length; i++) {
            this.strengths[i] = 0;
            this.oscillations[i] = 0;
            this.oscillationsY[i] = 0;
            this.sizes[i] = 0;
        }
        this.frameStart = this.sketch.frameCount;

        this.phaseNumber = 1;
    }

    draw() {

        //sum = d.sum();
        this.sum = this.dp.sum();


        if (this.dp.shouldSwitchPhase() == true) {

            this.pushPhase();

        }

        //if (sum < 10) {
        //  updateCenter();
        //}

        for (let i = 0; i < this.ps.systemParticles().length; i++) {

            let p = this.ps.systemParticles()[i];
            let px = p.cx;
            let py = p.cy;
            let ox = p.oscillationXValue;
            let oy = p.oscillationYValue;

            let scaledMaxDistanceFromEpicenter = this.maxDistanceFromEpicenter * this.sketch.constrain(this.sum / 1000, 0, 1);

            let distanceFromEpicenter = this.sketch.dist(this.center.x, this.center.y, px, py);
            let distanceStrength = this.sketch.max(0, 1 - (distanceFromEpicenter / scaledMaxDistanceFromEpicenter));
            let strengthAddition = distanceStrength * strengthIncrement;



            if (this.phaseNumber == 1) {

                if (this.sum >= 10) {
                    let newStrengthValue = this.sketch.constrain(ox + strengthAddition, 0, 1);

                    if (newStrengthValue != p.oscillationXValue) {

                        p.updateOscillationX(newStrengthValue);
                    }
                }



                if (p.oscillationXValue > 0.01 && p.isOscillationX == false) {
                    p.updateOscillationXFrameCount(this.sketch.frameCount);
                }


                if (p.isOscillationX) {

                    p.updateOscillationPosition();

                }
            } else if (this.phaseNumber == 2) {

                if (this.sum >= 10) {
                    let newStrengthValue = this.sketch.constrain(oy + strengthAddition, 0, 1);

                    if (newStrengthValue != p.oscillationYValue) {

                        p.updateOscillationY(newStrengthValue);
                    }
                }


                if (p.oscillationYValue > 0.01 && p.isOscillationY == false) {
                    p.updateOscillationYFrameCount(this.sketch.frameCount);
                }

                if (p.isOscillationX || p.isOscillationY) {

                    p.updateOscillationPosition();
                }
            }
        }

        this.ps.render();
    }




    pushPhase() {

        if (this.phaseNumber < 2) {

            this.phaseNumber += 1;
        } else {

            this.phaseNumber = 1;

        }
    }




    moveCenter(x, y) {
        this.center = this.sketch.createVector(x, y);
    }
}

export default SwayStudy;